import styled from 'styled-components';

const AnalysisResultStyled = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .analysis-wrap {
    flex-direction: row;
    padding: 24px 0;
    margin-top: 4px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    height: 160px;
    justify-content: space-around;
    .analysis-content-left,
    .analysis-content-right,
    .analysis-content-member {
      border-right: 1px solid #eeeeee;
    }
    .box-wrap-right {
      flex: 1 auto;
      justify-content: space-around;
      .register-title-wrap {
        align-items: center;
      }
    }
    .box-wrap-right,
    .box-wrap-left {
      display: flex;
      flex-direction: row;
      /* flex:1 auto; */
      justify-content: space-between;
    }

    .analysis-content-left,
    .analysis-content-right {
      padding: 0 30px;
      .left-title {
        font-size: 16px;
        font-weight: 500;
        color: #646464;
        line-height: 22px;
        word-break: keep-all;
        margin-top: 4px;
      }
      .left-title-en {
        font-size: 10px;
        color: #cccccc;
        line-height: 12px;
        word-break: keep-all;
      }
    }
    .analysis-content-left,
    .analysis-content-right {
      .right-title-en {
        font-size: 28px;
        font-weight: bold;
        color: #1565c0;
        line-height: 34px;
      }
      .right-title-en-num {
        font-size: 12px;
        font-weight: bold;
        color: #424242;
        line-height: 15px;
        display: flex;
        align-items: flex-start;
        margin-top: 4px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #1565c0;
          line-height: 34px;
        }
      }
    }
    .analysis-content-left {
      .right-title-en {
        margin-top: 4px;
      }
    }

    /* .analysis-content-left:first-of-type {
      padding-left: 0;
    } */
    .analysis-content-left:last-of-type {
      border: none;
    }
    .analysis-content-right {
      padding: 0 30px;
      border: 0;
      .right-title-en-num {
        font-size: 12px;
        font-weight: bold;
        color: #424242;
        line-height: 15px;
        display: flex;
        align-items: flex-start;
        margin-top: 4px;
        span {
          font-size: 28px;
          font-weight: bold;
          color: #1565c0;
          line-height: 34px;
        }
      }
    }
    .analysis-content-right,
    .analysis-content-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 112px;
      padding: 0;
      flex: 1;
    }
    .content-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      height: 106px;
      flex: 1;
    }
    .register-title-wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .content-left {
      border-radius: 10px;
      /* padding: 16px 0 8px; */
      /* gap: 8px; */
      .left-title {
        font-size: 16px;
        font-weight: 500;
        color: #646464;
        line-height: 22px;
        word-break: keep-all;
        padding-top: 20px;
      }
      .left-title-en {
        font-size: 10px;
        color: #cccccc;
        line-height: 12px;
        word-break: keep-all;
      }
    }
    .analysis-content-member {
      width: 100%;
      display: flex;
      flex-direction: column;
      /* justify-content: space-between; */
      align-items: center;
      padding: 0 30px;
      .content-bottom {
        display: flex;
        flex-direction: column;
        align-items: center;
        .right-title-en {
          font-size: 28px;
          font-weight: bold;
          color: #1565c0;
          line-height: 34px;
          margin: 4px 0;
        }
        .right-title-num {
          font-size: 14px;
          font-weight: 400;
          color: #212121;
          line-height: 18px;
        }
      }
    }
  }
  .table-wrap {
    flex-grow: 1;
    margin-top: 4px;
    position: relative;
    width: 100%;
    background: #fff;
    border-radius: 12px;
    .export-wrapper {
      height: 34px;
      position: absolute;
      top: 24px;
      right: 32px;
      z-index: 12;
      .export {
        width: 80px;
        color: #fff;
        float: right;
        .MuiSvgIcon-root {
          margin-right: 8px;
        }
      }
    }
    .title-column {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 9px;
        height: 18px;
        margin-left: 7px;
        cursor: pointer;
      }
      span {
        width: 30px;
      }
    }
  }
`;

export default AnalysisResultStyled;
